<div class="mat-typography h-screen flex flex-col">
  <div class="header-border">
    <app-header
      [initData]="initService.InitData"
      [quota]="permissionService.quota()"
      [userLocale]="initService.InitData.language"
      (languageChanged)="optionService.useLanguage($event)"
      (openCacheClicked)="openCacheDialog()"
      (goToHomeClicked)="goToHome()"
      [navigationItems]="subheaderNavigationService.navigationItems()"
      (navigationItemClicked)="subheaderNavigationService.setModule($event)"
      [hasChangeRightPermission]="permissionService.hasChangeRightPermission"
      [hasShopPermission]="hasShop$ | async"
      [hasAppSynchronizationPermission]="permissionService.isAllowed('AppSynchronization')"
    />
  </div>

  <div class="flex-1 overflow-hidden">
    <router-outlet />
  </div>

  @if (loadingService.isLoading()) {
    <app-loading />
  }
</div>
